// Mock data for Unifi website clone

export const heroSlides = [
  {
    id: 1,
    subtitle: "Sign up to unifi home™",
    title: "START YOUR SEAMLESS\nINTERNAL SURFING\nEXPERIENCE NOW!",
    image: "/images/hero/seamless.png"
  },
  {
    id: 2,
    subtitle: "Sign up to unifi home™",
    title: "FAST, EASY\nUNIFI SIGNUP WITH\nOUR AUTHORISED AGENT",
    image: "/images/hero/fast.png"
  }
];

export const features = [
  {
    id: 1,
    icon: "https://www.unifi.com.co/assets/images/icon_install.gif",
    title: "Free Installation"
  },
  {
    id: 2,
    icon: "https://www.unifi.com.co/assets/images/icon_streaming.gif",
    title: "Largest Streaming\nApps Selection"
  },
  {
    id: 3,
    icon: "https://www.unifi.com.co/assets/images/icon_24h.gif",
    title: "24 hours Service\nRestoration"
  }
];

export const whyRegisterSteps = [
  {
    id: 1,
    icon: "smartphone",
    title: "Fill in the form"
  },
  {
    id: 2,
    icon: "file-text",
    title: "Submit documents"
  },
  {
    id: 3,
    icon: "clock",
    title: "24hrs process time"
  },
  {
    id: 4,
    icon: "router",
    title: "Installation"
  },
  {
    id: 5,
    icon: "wifi",
    title: "Done! Enjoy your high\nspeed internet"
  }
];

export const homePackages = [
  {
    id: 1,
    speed: "100Mbps",
    badge: "",
    recommended: "Great for small households and apartments",
    users: "Recommended for 2-4 users/devices",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>100mbps</b><br/>Upload speed up to <b>50mbps</b>" },
      { icon: "router", text: "Wi-Fi 6 Combo Box", subtext: "" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM89",
    originalPrice: "RM99/month",
    contract: "24-month contract",
    optionalList: [
      {
        name: "Netflix Basic",
        price: 29,
        image: "/images/addons/netflix.png",
        details: [
          "Unlimited ad-free movies, TV shows, and mobile games",
          "Watch & Download on 1 supported device at a time",
          "Watch in HD"
        ]
      },
      {
        name: "Max Standard",
        price: 24,
        image: "/images/addons/max.png",
        details: [
          "Enjoy blockbusters, groundbreaking series, iconic hits, real-life stories and family favorites from HBO, Harry Potter, the DC Universe, Cartoon Network, Warner Bros. and Discovery, with Max",
          "Watch in HD",
          "Download & watch on 2 supported devices at a time"
        ]
      }
    ],
    deviceAddon: {
      type: "free-months",
      name: "Free 6 Month",
      contract: "36-month contract",
      note: "Enjoy 6 free month on a 36-month plan",
      contractOverride: "36-month contract",
      price: 0,
      priceLabel: "FREE"
    }
  },
  {
    id: 3,
    speed: "300Mbps",
    badge: "",
    bestSeller: true,
    recommended: "Optimal for families, home offices, and townhouses",
    users: "Recommended for 4-6 users/devices",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>300mbps</b><br/>Upload speed up to <b>50mbps</b>" },
      { icon: "router", text: "Wi-Fi 6 Combo Box", subtext: "" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM129",
    originalPrice: "",
    contract: "24-month contract",
    deviceAddonList: [
      {
        type: "camera",
        name: "RM59\nFirst 10 Month,\nFree 1x AI Indoor Camera",
        price: 59,
        priceLabel: "RM59/mth",
        contract: "24-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "24-month contract",
        priceOverride: {
          amount: "RM59.00",
          period: "for First 10 month",
          strikeThrough: "RM129/month"
        },
        includesAdd: [
          { icon: "camera", text: "1x AI Indoor Camera", subtext: "" },
          { icon: "cloud", text: "7Days Video Cloud Storage", subtext: "" }
        ]
      },
      {
        type: "free-months",
        name: "Free 6 Month",
        price: 0,
        priceLabel: "FREE",
        contract: "30-month contract",
        note: "Enjoy 6 free month on a 30-month plan",
        contractOverride: "30-month contract"
      },
      {
        type: "tv",
        name: "43\"\nSmart TV",
        price: 20,
        contract: "36-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "36-month contract"
      }
    ]
  },
  {
    id: 5,
    speed: "500Mbps",
    badge: "",
    recommended: "Perfect for gamers and streamers in houses",
    users: "Recommended for 6-8 users/devices",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>500mbps</b><br/>Upload speed up to <b>100mbps</b>" },
      { icon: "router", text: "Wi-Fi 6 Combo Box", subtext: "" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM149",
    originalPrice: "",
    contract: "24-month contract",
    deviceAddonList: [
      {
        type: "camera",
        name: "RM79\nFirst 10 Month,\nFree 1x AI Indoor Camera",
        price: 79,
        priceLabel: "RM79/mth",
        contract: "24-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "24-month contract",
        priceOverride: {
          amount: "RM79.00",
          period: "for First 10 month",
          strikeThrough: "RM149/month"
        },
        includesAdd: [
          { icon: "camera", text: "1x AI Indoor Camera", subtext: "" },
          { icon: "cloud", text: "7Days Video Cloud Storage", subtext: "" }
        ]
      },
      {
        type: "free-months",
        name: "Free 6 Month",
        price: 0,
        priceLabel: "FREE",
        contract: "30-month contract",
        note: "Enjoy 6 free month on a 30-month plan",
        contractOverride: "30-month contract"
      },
      {
        type: "tv",
        name: "55\"\nSmart TV",
        price: 20,
        contract: "36-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "36-month contract"
      },
      {
        type: "tv",
        name: "65\"\nSmart TV",
        price: 40,
        contract: "36-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "36-month contract"
      }
    ]
  },
  {
    id: 6,
    speed: "1Gbps",
    badge: "FREE 6 MONTH",
    recommended: "Lightning-fast speed for power users in larger homes",
    users: "Recommended for 8-10+ users/devices",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>1Gbps</b><br/>Upload speed up to <b>500mbps</b>" },
      { icon: "router", text: "Wi-Fi 7 Combo Box", subtext: "" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM249",
    originalPrice: "",
    contract: "30-month contract + Free 6 Month",
    hideAddonsByDefault: true,
    optionalList: [
      {
        name: "Netflix Standard",
        price: 34,
        image: "/images/addons/netflix.png",
        details: [
          "Unlimited ad-free movies, TV shows, and mobile games",
          "Watch & Download on 2 supported devices at a time",
          "Watch in Full-HD 1080P"
        ]
      },
      {
        name: "Max Standard",
        price: 14,
        image: "/images/addons/max.png",
        details: [
          "Enjoy blockbusters, groundbreaking series, iconic hits, real-life stories and family favorites from HBO, Harry Potter, the DC Universe, Cartoon Network, Warner Bros. and Discovery, with Max",
          "Watch in HD",
          "Download & watch on 2 supported devices at a time"
        ]
      }
    ],
    deviceAddonList: [
      {
        type: "tv",
        name: "65\"\nSmart TV",
        price: 20,
        contract: "36-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "36-month contract"
      },
      {
        type: "tv",
        name: "75\"\nSmart TV",
        price: 40,
        contract: "36-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "36-month contract"
      }
    ]
  },
  {
    id: 7,
    speed: "2Gbps",
    badge: "",
    recommended: "The ultimate internet experience for large households",
    users: "Recommended for 8-10+ users/devices",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>2Gbps</b><br/>Upload speed up to <b>1Gbps</b>" },
      { icon: "router", text: "Wi-Fi 7 Combo Box", subtext: "" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM319",
    originalPrice: "",
    contract: "24-month contract"
  }
];

// Business plans — same card layout as Home, but no promos/addons and uniform 24-month contract.
export const businessPackages = [
  {
    id: 101,
    speed: "BIZ 100Mbps",
    badge: "",
    recommended: "Flexible Micro Office",
    users: "Supports up to 2-3 users on 5 devices.",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>100mbps</b><br/>Upload speed up to <b>50mbps</b>" },
      { icon: "router", text: "Wi-Fi 6 Combo Box", subtext: "" },
      { icon: "clock", text: "Service Restoration within 24 hours", subtext: "" },
      { icon: "phone-alt", text: "Free DECT Phone", subtext: "" },
      { icon: "phone", text: "Pay Per Use Voice Plan", subtext: "20 cents/min" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM99",
    originalPrice: "",
    contract: "24-month contract"
  },
  {
    id: 102,
    speed: "BIZ 300Mbps",
    badge: "",
    bestSeller: true,
    recommended: "Small Outlet Office or Small NGO Office",
    users: "Supports up to 6 users on 10 devices.",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>300mbps</b><br/>Upload speed up to <b>100mbps</b>" },
      { icon: "router", text: "Wi-Fi 6 Combo Box", subtext: "" },
      { icon: "clock", text: "Service Restoration within 24 hours", subtext: "" },
      { icon: "phone-alt", text: "Free DECT Phone", subtext: "" },
      { icon: "phone", text: "Pay Per Use Voice Plan", subtext: "20 cents/min" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM139",
    originalPrice: "",
    contract: "24-month contract",
    deviceAddonList: [
      {
        type: "free-months",
        name: "Free 6 Month",
        price: 0,
        priceLabel: "FREE",
        contract: "30-month contract",
        note: "Enjoy 6 free month on a 30-month plan",
        contractOverride: "30-month contract"
      },
      {
        type: "ipad",
        name: "Apple 11\"\niPad 128GB",
        price: 26,
        contract: "36-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "36-month contract"
      },
      {
        type: "tv",
        name: "43\"\nSmart TV",
        price: 20,
        contract: "36-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "36-month contract"
      }
    ]
  },
  {
    id: 103,
    speed: "BIZ 500Mbps",
    badge: "",
    recommended: "Virtual Office / Shop",
    users: "Supports up to 10 heavy users on multiple devices.",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>500mbps</b><br/>Upload speed up to <b>200mbps</b>" },
      { icon: "router", text: "Wi-Fi 6 Combo Box", subtext: "" },
      { icon: "clock", text: "Service Restoration within 24 hours", subtext: "" },
      { icon: "phone-alt", text: "Free DECT Phone", subtext: "" },
      { icon: "phone", text: "Pay Per Use Voice Plan", subtext: "20 cents/min" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM179",
    originalPrice: "",
    contract: "24-month contract",
    deviceAddonList: [
      {
        type: "free-months",
        name: "Free 6 Month",
        price: 0,
        priceLabel: "FREE",
        contract: "30-month contract",
        note: "Enjoy 6 free month on a 30-month plan",
        contractOverride: "30-month contract"
      },
      {
        type: "ipad",
        name: "Apple 11\"\niPad 128GB",
        price: 26,
        contract: "36-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "36-month contract"
      },
      {
        type: "tv",
        name: "55\"\nSmart TV",
        price: 10,
        contract: "36-month contract",
        note: "Device delivered 2-4 weeks after installation",
        contractOverride: "36-month contract"
      }
    ]
  },
  {
    id: 104,
    speed: "BIZ 1Gbps",
    badge: "",
    recommended: "Larger Business Premise Setting",
    users: "Supports up to 10 power users on multiple devices.",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>1Gbps</b><br/>Upload speed up to <b>500mbps</b>" },
      { icon: "router", text: "Wi-Fi 7 Combo Box", subtext: "" },
      { icon: "signal", text: "Wi-Fi 7 Combo Box Mesh", subtext: "" },
      { icon: "clock", text: "Service Restoration within 12 hours", subtext: "" },
      { icon: "phone-alt", text: "Free DECT Phone", subtext: "" },
      { icon: "gift", text: "Free Simple Voice Plus worth RM70", subtext: "FREE Call Credit RM70" },
      { icon: "phone", text: "Pay Per Use Voice Plan", subtext: "20 cents/min" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM319",
    originalPrice: "",
    contract: "24-month contract"
  },
  {
    id: 105,
    speed: "BIZ 2Gbps",
    badge: "",
    recommended: "Larger Business Premise Setting",
    users: "Ultimate support for up to 10 power users on multiple devices.",
    includes: [
      { icon: "wifi", text: "Unlimited Data", subtext: "Download speed up to <b>2Gbps</b><br/>Upload speed up to <b>1Gbps</b>" },
      { icon: "router", text: "Wi-Fi 7 Combo Box", subtext: "" },
      { icon: "signal", text: "Wi-Fi 7 Combo Box Mesh", subtext: "" },
      { icon: "clock", text: "Service Restoration within 12 hours", subtext: "" },
      { icon: "phone-alt", text: "Free DECT Phone", subtext: "" },
      { icon: "gift", text: "Free Simple Voice Plus worth RM70", subtext: "FREE Call Credit RM70" },
      { icon: "phone", text: "Pay Per Use Voice Plan", subtext: "20 cents/min" },
      { icon: "tools", text: "Fast Installation & Free Installation", subtext: "Installation*" }
    ],
    price: "RM369",
    originalPrice: "",
    contract: "24-month contract"
  }
];

export const businessFiestaPackages = [];

export const testimonials = [
  {
    id: 1,
    name: "Aiman Hakim",
    image: "https://www.unifi.com.co/assets/images/feedback-3.png",
    rating: 5
  },
  {
    id: 2,
    name: "Nur Aisyah",
    image: "https://www.unifi.com.co/assets/images/feedback-1.png",
    rating: 5
  },
  {
    id: 3,
    name: "Cik Ezaura",
    image: "https://www.unifi.com.co/assets/images/feedback-4.png",
    rating: 5
  },
  {
    id: 4,
    name: "Cik Sharizah",
    image: "https://www.unifi.com.co/assets/images/feedback-2.png",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    title: "Unifi Home Free 3 Months Prime Promo Campaign FAQ",
    link: "#"
  },
  {
    id: 2,
    title: "Unifi UniVerse Campaign FAQ",
    link: "#"
  },
  {
    id: 3,
    title: "Upgrading Your Existing Plans To New Platform Plans FAQ",
    link: "#"
  },
  {
    id: 4,
    title: "General FAQ for unifi Home",
    link: "#"
  },
  {
    id: 5,
    title: "UNIFI TV PACKS FAQ",
    link: "#"
  }
];

export const termsConditions = [
  {
    id: 1,
    title: "Unifi Home Free 3 Months Prime Promo Campaign T&C",
    link: "#"
  },
  {
    id: 2,
    title: "UniVerse Campaign T&C",
    link: "#"
  },
  {
    id: 3,
    title: "General T&C for unifi Home",
    link: "#"
  },
  {
    id: 4,
    title: "UNIFI TV PACK(S) SUBSCRIPTION T&C",
    link: "#"
  }
];
